import React from "react";
import { Button } from "@material-ui/core";
import { useNavigate } from "react-router-dom";
import errorImg from "../../../../assets/error_red_exclamation.svg";
import successGif from "../../../../assets/done-animation.gif";

interface AptCreatedButLinkNotGeneratedProps {
  appointmentCreated: any;
  props: any;
  profileDetails: any;
}

const AptCreatedButLinkNotGenerated: React.FC<
  AptCreatedButLinkNotGeneratedProps
> = ({ appointmentCreated, props, profileDetails }) => {
  const navigate = useNavigate();
  return (
    <div
      className="pld-screen pld-method-container"
      style={{
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        height: "100%",
      }}
    >
      {/* SUCCESS GIF */}
      <div style={{ marginTop: "25px" }}>
        <img src={successGif} alt="success" height="170px" />
      </div>

      {/* TITLE */}
      <div style={{ fontWeight: "bold", fontSize: "22px", margin: "10px 0px" }}>
        Appointment created successfully!
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginBottom: "10px",
        }}
      >
        <div
          className="show-shared-options-box zy-dashed-border"
          style={{
            fontWeight: "500",
            fontSize: "18px",
          }}
        >
          {"Appointment ID: " + appointmentCreated?.id}
        </div>
      </div>

      <div className="zy-dashed-border" style={{ padding: "20px" }}>
        {/* ERROR IMAGE */}
        <div>
          <img src={errorImg} alt="error" height="50px" />
        </div>

        {/* NOTE BOX */}
        <div className="pld-note-container" style={{ marginTop: "15px" }}>
          <div className="pld-note-box">
            <span className="pld-bold">Error in generating payment link</span>
          </div>
        </div>

        {/* BUTTON */}
        <div className="pld-center" style={{ marginTop: "10px" }}>
          <Button
            className="zy-btn-orange pld-main-btn"
            onClick={() => {
              navigate(`/view?id=${profileDetails?.id}`, { replace: true });
            }}
          >
            Try generating link again
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AptCreatedButLinkNotGenerated;
